import {QuestionList} from '../../types';
import Img from '../../img/scenes/page_08.jpg'

export const Day6: QuestionList = [{
    id: 101,
    img: Img,
    question: `Ви отримуєте непогане замовлення в новий для себе мікрорайон міста. Пасажир сідає й одразу запитує, чи ви місцевий. Що відповідаєте?`,
    answers: [
        {
            id: 1,
            text: 'Чесно кажу, що ні',
            next: 102,
        },
        {
            id: 2,
            text: 'Намагаюсь віджартуватись, що у Києві давно не лишилось справжніх місцевих',
            next: 102,
        },
    ],
}, {
    id: 102,
    question: `Пасажир киває та просить не дивитись у навігатор, а дослухатися його порад. Він народився і виріс у Києві, сам тривалий час працював у таксі, тож знає тут кожен камінь. Просить їхати маловідомою дорогою, про яку знають лише місцеві. Погоджуєтесь?`,
    answers: [
    {
        id: 1,
        text: 'Так',
        next: 103,
    },
    {
        id: 2,
        text: 'Ні, не знаю дорогу, у випадку чогось, не хочу намотувати зайві кілометри',
        next: 201,
    },
],
},
    {
        id: 201,
        question: `Пасажир заводить ностальгічну промову про часи, коли всі водії знали місто, а навігаторів взагалі не існувало. Підтримати розмову?`,
        answers: [
            {
                id: 1,
                text: 'Ні, це марно',
                next: 202,
            },
            {
                id: 2,
                text: 'Так, скажу, що за тих часів я б зараз взагалі не мав роботи',
                next: 203,
            },
        ],
    },

    {
        id: 202,
        question: `Пасажир розчарований ще й вашим мовчанням. Ви їдете решту шляху мовчки.`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 204,
            },
        ],
    },
    {
        id: 204,
        question: `Завершивши поїздку, ви отримуєте 3 зірки від любителя поностальгувати.`,
        rate: 3,
        answers: [
            {
                id: 1,
                text: 'Перейти до результатів',
                next: 0,
            },
        ],
    },
    {
        id: 203,
        question: `У вас зав'язується розмова про сьогодення, економіку й політику. Ви б говорили ще годину, якби поїздку не було завершено.`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 205,
            },
        ],
    },
    {
        id: 205,
        question: `Пасажир поставив вам 4 зірки і відгук, як про чудового співрозмовника.`,
        rate: 4,
        answers: [
            {
                id: 1,
                text: 'Перейти до результатів',
                next: 0,
            },
        ],
    },
    {
        id: 103,
        question: `<p>Ви починаєте їхати. Все йде за планом. Раптом, помічаєте попередження про ремонт дороги й тупик. Пасажир зітхає й говорить, що давно тут не їздив і не очікував, що все перекрито.</p>

<p>Далі їхатимете за навігатором чи порадами цього чоловіка?</p>`,
        answers: [
            {
                id: 1,
                text: 'Продовжую слухати пасажира',
                next: 104,
            },
            {
                id: 2,
                text: 'Далі за навігатором, урок вивчено',
                next: 206,
            },
        ],
    },
    {
        id: 206,
        question: `Пасажир заводить ностальгічну промову про часи, коли всі водії знали місто, а навігаторів взагалі не існувало. Підтримати розмову?`,
        answers: [
            {
                id: 1,
                text: 'Ні, це марно',
                next: 207,
            },
            {
                id: 2,
                text: 'Так, скажу, що за тих часів я би зараз взагалі не мав роботи',
                next: 208,
            },
        ],
    },
    {
        id: 207,
        question: `Пасажир розчарований ще й вашим мовчанням. Ви їдете решту шляху мовчки.`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 210,
            },
        ],
    },
    {
        id: 210,
        question: `Завершивши поїздку, ви отримуєте 4 зірки від любителя поностальгувати.`,
        rate: 4,
        answers: [
            {
                id: 1,
                text: 'Перейти до результатів',
                next: 0,
            },
        ],
    },
    {
        id: 208,
        question: `У вас зав'язується розмова про сьогодення, економіку й політику. Ви б говорили ще годину, якби поїздку не було завершено.`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 211,
            },
        ],
    },
    {
        id: 211,
        question: `Пасажир поставив вам 5 зірок і відгук, як про чудового співрозмовника`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'Перейти до результатів',
                next: 0,
            },
        ],
    },
    {
        id: 104,
        question: `До кінця шляху маловідома дорога для місцевих не робить більше сюрпризів, проте ви бачите, що геть не виграли за кілометражем і навіть намотали трохи більше. Сказати про це?`,
        answers: [
            {
                id: 1,
                text: 'Ні',
                next: 105,
            },
            {
                id: 2,
                text: 'Так',
                next: 212,
            },
        ],
    },
    {
        id: 105,
        question: `Пасажир радісно з вами прощається. Думає, що йому вдалося вас вразити й скоротити шлях. Ви отримуєте 5 зірок від пасажира.`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'Перейти до результатів',
                next: 0,
            },
        ],
    },
    {
        id: 212,
        question: `Пасажир здивовано на вас дивиться й не вірить вашим словам. На цьому ви й прощаєтесь. Ви отримуєте 4 зірки за поїздку.`,
        rate: 4,
        answers: [
            {
                id: 1,
                text: 'Перейти до результатів',
                next: 0,
            },
        ],
    },


];
